import { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Menu, ListItemText, Box } from 'components/ui';
import { ArrowDropDownIcon, ArrowDropUpIcon, CheckIcon, AddIcon, ProbelistWorkspaceSwitchIcon } from 'components/uiIcons';
import { ListMenuItem, MenuButton } from 'components/styles_components/menu';
import { useSpace } from 'contexts/space';
import { DashboardLink, SpacesLink, hardRedirect } from 'utils/link';
import SpacesQuery from 'queries/space';
import theme from 'theme';
import { LimitedSpan } from 'components/styles_components/span';

const SpaceSelector = ({ currentName, isMobile }) => {
  const intl = useIntl();
  const { currentSpaceId, selectSpace, clearSpace } = useSpace();
  const [spaceAnchorEl, setSpaceAnchorEl] = useState(null);
  const spaceOpen = Boolean(spaceAnchorEl);

  const { data = { spaces: { spaces: [] }, invitedSpaces: { spacesTotal: 0 } } } = useQuery(SpacesQuery, {
    variables: { page: 1 },
    fetchPolicy: 'cache-first',
  });
  const spaces = data.spaces.spaces;

  const handleSpaceClick = (event) => {
    setSpaceAnchorEl(event.currentTarget);
  };

  const handleSpaceClose = () => {
    setSpaceAnchorEl(null);
  };

  const onSpaceItemClick = (id) => {
    if (id === currentSpaceId) {
      handleSpaceClose();
      return;
    }
    selectSpace(id);
    hardRedirect(DashboardLink());
  };

  const onManageClick = () => {
    clearSpace();
    hardRedirect(SpacesLink());
  };

  const icon = spaceOpen ? (
    <ArrowDropUpIcon aria-hidden="true" />
  ) : (
    <ArrowDropDownIcon aria-hidden="true" />
  );

  return (
    <>
      <MenuButton
        aria-label={intl.formatMessage({ id: 'navbar.space' })}
        aria-haspopup="menu"
        aria-expanded={spaceOpen}
        aria-controls={spaceOpen ? 'space-selector-menu' : undefined}
        sx={
          spaceOpen
            ? {
                backgroundColor: theme.palette.custom.whiteGreen,
                '&:hover': { backgroundColor: theme.palette.custom.whiteGreen },
              }
            : undefined
        }
        onClick={handleSpaceClick}
      >
        <ProbelistWorkspaceSwitchIcon aria-hidden="true" sx={ isMobile ? {} : { mr: 1 }} />{!isMobile && <LimitedSpan component="span">{currentName}</LimitedSpan>} {icon}
      </MenuButton>
      <Menu
        id="space-selector-menu"
        anchorEl={spaceAnchorEl}
        open={spaceOpen}
        onClose={handleSpaceClose}
      >
        {spaces.map((space) => {
          const isCurrent = space.id === currentSpaceId;
          return (
            <ListMenuItem
              key={space.id}
              selected={isCurrent}
              onClick={() => onSpaceItemClick(space.id)}
            >
              <span className="pre" />
              {isCurrent ? (
                <CheckIcon aria-hidden="true" />
              ) : (
                <Box sx={{ width: 24 }} aria-hidden="true" />
              )}
              <ListItemText>{space.name}</ListItemText>
            </ListMenuItem>
          );
        })}
        {data.invitedSpaces.spacesTotal > 0 && (
          <ListMenuItem onClick={onManageClick}>
            <AddIcon aria-hidden="true" />
            <ListItemText>
              <FormattedMessage id="spaces.invitations.title" />
            </ListItemText>
          </ListMenuItem>
        )}
      </Menu>
    </>
  );
};

export default SpaceSelector;
